<template src="./html/Datatable.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import SendEmail from './SendEmail.vue'
	import FileSaver from 'file-saver'
	import Actions from './Actions'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'

	export default {
		props: ['user', 'isAuth', 'customer'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'send-email': SendEmail,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/invoices/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							sales: false,
							purchases: false,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'number',
							sortField: 'number',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: this.fileds,
				},

				fields: [
					{
						name: '__slot:number',
						title: this.$platform.setting.number_symbol,
					},
					{
						name: '__slot:reference',
						title: 'Ref.',
						sortField: 'reference',
					},
					{
						name: '__slot:customer',
						title: 'Cliente',
					},
					{
						name: '__slot:provider',
						title: 'Proveedor',
					},
					{
						name: '__slot:base_amount',
						title: 'Precio',
						sortField: 'base_amount',
					},
					{
						name: '__slot:taxes',
						title: 'Impuestos',
						sortField: 'taxes',
					},
					{
						name: '__slot:amount',
						title: 'Base imponible',
						sortField: 'amount',
					},
					{
						name: '__slot:total',
						title: 'Total',
						sortField: 'total',
					},
					{
						name: '__slot:status',
						title: 'Estado',
						sortField: 'invoice_status_id',
					},
					{
						name: '__slot:author',
						title: 'Autor',
					},
					{
						name: 'created_at',
						title: 'Fecha',
						callback: function(value) {
							return moment(value).format('DD/MM/YY')
						},
						sortField: 'created_at',
					},
					{
						name: '__slot:dropdown',
						title: '',
					}
				],

				salesFields: [
					{
						name: '__slot:number',
						title: this.$platform.setting.number_symbol,
						sortField: 'number',
					},
					{
						name: '__slot:customer',
						title: 'Cliente',
						visible: (this.customer) ? false : true,
					},
					{
						name: '__slot:base_amount',
						title: 'Precio',
						sortField: 'base_amount',
					},
					{
						name: '__slot:taxes',
						title: 'Impuestos',
						sortField: 'taxes',
					},
					{
						name: '__slot:amount',
						title: 'Base imponible',
						sortField: 'amount',
					},
					{
						name: '__slot:total',
						title: 'Total',
						sortField: 'total',
					},
					{
						name: '__slot:author',
						title: 'Autor',
					},
					{
						name: 'created_at',
						title: 'Fecha',
						callback: function(value) {
							return moment(value).format('DD/MM/YY')
						},
						sortField: 'created_at',
					},
					{
						name: '__slot:status',
						title: 'Estado',
					},
					{
						name: '__slot:dropdown',
						title: '',
					}
				],

				purchasesFields: [
					{
						name: '__slot:number',
						title: this.$platform.setting.number_symbol,
						sortField: 'number_invoice_provider',
					},
					{
						name: '__slot:reference',
						title: 'Ref.',
						sortField: 'reference',
					},
					{
						name: '__slot:provider',
						title: 'Proveedor',
					},
					{
						name: '__slot:order',
						title: 'Pedido',
					},
					{
						name: '__slot:base_amount',
						title: 'Precio',
						sortField: 'base_amount',
					},
					{
						name: '__slot:taxes',
						title: 'Impuestos',
						sortField: 'taxes',
					},
					{
						name: '__slot:amount',
						title: 'Base imponible',
						sortField: 'amount',
					},
					{
						name: '__slot:total',
						title: 'Total',
						sortField: 'total',
					},
					{
						name: '__slot:status',
						title: 'Estado',
						sortField: 'invoice_status_id',
					},
					{
						name: '__slot:author',
						title: 'Autor',
					},
					{
						name: 'created_at',
						title: 'Fecha',
						callback: function(value) {
							return moment(value).format('DD/MM/YY')
						},
						sortField: 'created_at',
					},
					{
						name: '__slot:dropdown',
						title: '',
					}
				],

				type: null,
				statuses: null,
			}
		},
		created() {
			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		watch: {
			'$route'() {
				this.changeType()
			}
		},
		methods: {
			init() {
				this.loadQuery()
				this.changeType()
				this.getStatuses()
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			getStatuses() {
				this.$http.get('admin/management/invoices/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			changeType() {
				this.type = null
				if(this.$route.meta) {
					if(this.$route.meta.type) {
						if(this.$route.meta.type == 'purchases') {
							this.type = 'purchases'
							this.datatable.moreParams.filter.purchases = true
							this.datatable.moreParams.filter.sales = false
							this.datatable.fields = this.purchasesFields
						} else {
							if(this.$route.meta.type == 'sales') {
								this.type = 'sales'
								this.datatable.moreParams.filter.sales = true
								this.datatable.moreParams.filter.purchases = false
								this.datatable.fields = this.salesFields
							} else {
								this.datatable.fields = this.fields
								this.datatable.moreParams.filter.sales = false
								this.datatable.moreParams.filter.purchases = false
							}
						}
					} else {
						if(this.customer) {
							this.datatable.fields = this.salesFields
							this.datatable.moreParams.filter.sales = false
							this.datatable.moreParams.filter.purchases = false
						} else {
							this.datatable.fields = this.fields
							this.datatable.moreParams.filter.sales = false
							this.datatable.moreParams.filter.purchases = false
						}
					}
				}
				this.reload()
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.normalizeFields())
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset() {
				this.clearFilter()
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			changeStatus(data) {
				var select = document.querySelector('#select-statuses-invoice-' + data.id)
				select.setAttribute('disabled', true)
				this.$http.get('admin/management/invoices/' + data.id + '/change/status/' + data.invoice_status_id)
					.then(response => {
						select.removeAttribute('disabled')
						this.reload()
					}).catch(response => {
						select.removeAttribute('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
						this.reload()
					})
			},
			downloadPdf(data) {
				var loading = Ladda.create(document.querySelector('#btn-dropdown-invoice-' + data.id))
				loading.start()
				this.$http.get('admin/management/invoices/' + data.id + '/download/pdf', {responseType: 'blob'})
				.then(response => {
					loading.stop()
					var file = response.body
					var blob = new Blob([file], {type: 'application/pdf'})
					var filename = this.$t('resources.invoices.invoice') + '-'
					if(data.prefix) {
						filename = filename + '-' + data.prefix
					}
					if(data.number) {
						filename = filename + '-' + data.number
					}
					if(data.customer) {
						filename = filename + '-' + data.customer.name
					}
					if(data.provider) {
						filename = filename + '-' + data.provider.name
					}
					filename = this.$options.filters.slugify(filename)

					FileSaver.saveAs(blob, filename)
				}).catch(response => {
					loading.stop()
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
					this.reload()
				})
			},
			rectify(data) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: 'Se generará una factura rectificativa',
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/invoices/' + data.id + '/rectify')
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								if(response.status == 409) {
									swal({
										title: response.body.title,
										text: response.body.text,
										type: 'warning',
									})
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									})
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			sendEmail(data) {
				this.$refs.SendEmail.open(data)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Datatable.vue